<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold">1950s</span></h2>
<p class="centerImagepa"><img alt="image" class="epubimage" src="Images/pa.jpg"/></p>
<p class="centerImage0"><img alt="image" class="epubimage" src="Images/13.jpg"/></p>
<p class="caption" style="text-indent:0%; margin-left:0%;"><em class="italic">Me at fifteen. Union Gap area, Washington, 1955.</em> <span class="smallCaps">USED WITH PERMISSION OF THE ESTATE OF AMY BURK UNGER.</span></p>
</div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429902687_pt01.vue?30773fff